import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { PenaltyManager } from "../../PenaltyManager";

    export class PenaltyCurtain extends Phaser.Group {

        private upperCurtain: Phaser.Sprite;
        private lowerCurtain: Phaser.Sprite;
        private penaltyLabel: Phaser.Text;
        private allOrNothingLabel: Phaser.Text;

        constructor(game: Phaser.Game) {

            super(game, null, "penalty curtain", false);

            // las cortinillas
            this.upperCurtain = new Phaser.Sprite(this.game, 0, GameConstants.GAME_HEIGHT / 2, this.game.cache.getBitmapData("penalty_curtain_gradient"));
            this.upperCurtain.scale.set(48, -4);
            this.add(this.upperCurtain);

            this.lowerCurtain = new Phaser.Sprite(this.game, 0, GameConstants.GAME_HEIGHT / 2, this.game.cache.getBitmapData("penalty_curtain_gradient"));
            this.lowerCurtain.scale.setTo(48, 4);
            this.add(this.lowerCurtain);

            this.upperCurtain.alpha = GameConstants.ALPHA_PHYSICS_BODIES;
            this.lowerCurtain.alpha = GameConstants.ALPHA_PHYSICS_BODIES;

            // los 2 mensajes
            this.penaltyLabel = new Phaser.Text(this.game, 800, 100, " " + GameVars.gameText.ONE_PENALTY + " ", {font: "150px whoopass", fill: "#DAE9E9"});
            this.penaltyLabel.scale.y = GameVars.scaleY;
            this.add(this.penaltyLabel);

            this.allOrNothingLabel = new Phaser.Text(this.game, -800, 825, " " + GameVars.gameText.ALL_NOTHING + " ", {font: GameVars.gameText.ALL_NOTHING_FONT_SIZE + "px whoopass", fill: "#DAE9E9"});
            this.allOrNothingLabel.scale.y = GameVars.scaleY;
            this.add( this.allOrNothingLabel);

            this.game.add.tween(this.penaltyLabel).to({x: 40}, 650,  Phaser.Easing.Cubic.In, true, 750);
            this.game.add.tween(this.allOrNothingLabel).to({x: 40}, 650, Phaser.Easing.Cubic.In, true, 1500)
                .onComplete.add(this.removeLabels, this);
        }

        private removeLabels(): void {

            this.game.add.tween( this.penaltyLabel ).to({x: -800}, 500, Phaser.Easing.Cubic.Out, true, 1200);
            this.game.add.tween( this.allOrNothingLabel ).to({x: 800}, 500, Phaser.Easing.Cubic.Out, true, 1200)
                .onComplete.add(this.removeCurtains, this);
        }

        private removeCurtains(): void {

            this.game.add.tween( this.upperCurtain ).to({y: 165}, 800,  Phaser.Easing.Cubic.In, true, 800);
            this.game.add.tween( this.lowerCurtain ).to({y: 830}, 800,  Phaser.Easing.Cubic.In, true, 800)
                .onComplete.add(this.onCurtainsRemoved, this);
        }

        private onCurtainsRemoved(): void {

            PenaltyManager.onMatchStart();
        }
    }
